export default {
  'Unauthorized': 'Usuário ou senha inválido.',
  'duplicate': 'Usuário já cadastrado.',
  'Forbidden': 'Não permitido.',
  'CandidateJobApplicationExisting': 'Você já se candidatou a essa vaga.',
  'Incorrect Password': 'Senha Incorreta.',
  'User Does Not Exist': 'Usuário não existe.',
  'User is Linked To a Company': 'Usuário está relacionado a uma empresa.',
  'User Is Not Linked To a Company': 'Usuário não está relacionado a uma empresa'
}